import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import OrderOutService from '@iso/services/OrderService/OrderOutService';

function* watchFetchOrderOut() {
    yield takeEvery(
        types.REQUEST_FETCH_ORDER_OUT,
        pagination('orderOut').saga(OrderOutService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchOrderOut),
    ]);
}

export default paginationSaga;